import { FunctionComponent, useCallback, useContext, useState } from "react";
import { EditorCtx } from "../../wysiwyg/EditorCtx";
import { PublicComponentProps } from "./PublicComponentProps";
import { ThemeButton } from "../ui/ThemeComponents/ThemeButton";
import { useNavigateToManagerAppByCode } from "../../helpers/manage";
import { ButtonProgress } from "../ui/ButtonProgress";
import { getManagerCodeAndBecomeSeller } from "../../dataAccess/api/managers";

export interface Settings {
  text: string;
}

const ManageProfileSignUpButton: FunctionComponent<
  PublicComponentProps<Settings>
> = ({ settings: { text } }) => {
  const [isManagerJwtLoading, setIsManagerJwtLoading] = useState(false);
  const { navigateToManagerAppByCode } = useNavigateToManagerAppByCode(
    setIsManagerJwtLoading,
  );
  const { isEditor, messages, setCurrentMessage } = useContext(EditorCtx);

  const becomeManageProfile = useCallback(() => {
    if (isEditor) {
      setCurrentMessage(messages.previewAlert);
      return;
    }
    navigateToManagerAppByCode(
      getManagerCodeAndBecomeSeller,
      "onboarding?returl=seller/home",
      { target: "_blank" },
    );
  }, [
    isEditor,
    messages.previewAlert,
    navigateToManagerAppByCode,
    setCurrentMessage,
  ]);

  return (
    <ThemeButton
      variant="contained"
      startIcon={isManagerJwtLoading && <ButtonProgress />}
      disabled={isManagerJwtLoading}
      onClick={becomeManageProfile}
    >
      {text}
    </ThemeButton>
  );
};

export default ManageProfileSignUpButton;
